import { configureStore } from '@reduxjs/toolkit'
import { useSelector as useReduxSelector, TypedUseSelectorHook } from 'react-redux'
import alertReducer from './slices/alertSlice'

const store = configureStore({
    reducer: {
        alert: alertReducer
    }
})

export default store

export type storeStateType = ReturnType<typeof store.getState>

export type storeDispatchType = typeof store.dispatch

export const useSelector: TypedUseSelectorHook<storeStateType> = useReduxSelector
